import React, { useState } from "react";

const MutantPowerRow = (props) => {

    const abilityID = props.item.id;

    const [isExpanded, setIsExpanded] = useState(false);

    // expand/collapse

    function toggleExpandDisplay() {
        setIsExpanded(!isExpanded);
    }

    // classes

    function classNames(classes) {
        return Object.entries(classes)
            .filter(([key, value]) => value)
            .map(([key, value]) => key)
            .join(' ');
    }

    const expandClasses = {
        'App-action-expandicon': true,
        'expand-icon--small': true,
        'expand-icon--selected': isExpanded
    };

    const expandClassNames = classNames(expandClasses);

    const labelClasses = {
        'App--action-label': true,
        'Expand-half': true,
        'App--action-label-expand': isExpanded
    };

    const labelClassNames = classNames(labelClasses);

    const descriptionClasses = {
        'App--action-desc': true,
        'Power-row-desc': true,
        'Expand-half-plus': true,
        'App--action-desc-expand': isExpanded
    };

    const descriptionClassNames = classNames(descriptionClasses);

    const titleClasses = {
        'App--action-title-label': true,
        'Title-label-small': true,
        'App--action-title-label-expand': isExpanded,
        'Title-expand-half': isExpanded
    };

    const titleClassNames = classNames(titleClasses);

    return (
        <div className="Create-general-power-row">
            <button type="button" onClick={toggleExpandDisplay}
                className="App--general-action-button">
                <div id={"action-display-" + abilityID}
                    className="App-action-expand-button">
                    <div className={expandClassNames} />
                </div>
                <div className={labelClassNames}>
                    <div className={titleClassNames} >{props.item.name}</div>
                    <div className={descriptionClassNames}
                        style={{marginTop:"-8px"} }>
                        {props.item.description}
                    </div>
                </div>
            </button>
            {
                !props.item.isInvestigative && (
                    <div className="Create-general-power-row-point-display">
                        {props.pointMap[abilityID]}
                    </div>
                )
            }
        </div>
        
    );
};

export default MutantPowerRow;